// removed by extract-text-webpack-plugin
module.exports = {"locale-EN":"locale-EN","field-editor-wrapper":"field-editor-wrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/CustomField/FieldEditorEN.scss
// module id = 1mDL
// module chunks = 0